var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChemSenseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ChemSense_Small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.87,3.8a10.09,10.09,0,0,0-7.13-3H144.16a9.73,9.73,0,0,0-7,2.87L137,3.8A10.12,10.12,0,0,0,144.16,21h2.64v87.12h0v74.71a16.08,16.08,0,0,0,4.71,11.38,16.25,16.25,0,0,0,22.88,0,16.08,16.08,0,0,0,4.71-11.38V98.26h0V21h2.64a9.71,9.71,0,0,0,7-2.88l.12-.11a10,10,0,0,0,0-14.25Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.55,39.85a10.35,10.35,0,0,1-3.46-2.31L46,37.42a9.78,9.78,0,0,1,7.16-16.63h35.3a9.66,9.66,0,0,1,6.91,2.81h0a10.08,10.08,0,0,1,2.94,7,9.77,9.77,0,0,1-2.94,6.9h0A8.73,8.73,0,0,1,92,39.85v37.6c1.28,2.69,3.33,6.91,6,12,12.28,24.43,35.69,71.12,35.69,82.5A27.22,27.22,0,0,1,125.78,191h0A27.22,27.22,0,0,1,106.72,199H34.84a27.36,27.36,0,0,1-18.93-7.8l-.13-.13A27,27,0,0,1,7.85,172c0-11.38,23.41-58.07,35.69-82.5,2.55-5.11,4.73-9.33,6-12Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemSenseSmall);
export default __webpack_public_path__ + "static/media/ChemSense_Small.7afd7385b535b9208b4cc1a936e108ef.svg";
export { ForwardRef as ReactComponent };